class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.bindHoverOpen();
  }

  // Desktop only — open submenu on hover. Touch devices keep tap-to-open.
  // Mobile drawer is a different component (header-drawer), not affected.
  bindHoverOpen() {
    const mq = window.matchMedia('(hover: hover) and (pointer: fine)');
    if (!mq.matches) return;

    const summary = this.mainDetailsToggle.querySelector('summary');

    const openMenu = () => {
      clearTimeout(this._closeT);
      if (!this.mainDetailsToggle.open) {
        this.mainDetailsToggle.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }
    };

    const scheduleClose = () => {
      clearTimeout(this._closeT);
      // grace delay so cursor can travel from summary → submenu without flicker
      this._closeT = setTimeout(() => {
        if (!this.matches(':hover') && !this.contains(document.activeElement)) this.close();
      }, 150);
    };

    this.addEventListener('mouseenter', openMenu);
    this.addEventListener('mouseleave', scheduleClose);
    // Click on summary while already hover-open → don't double-toggle shut
    summary && summary.addEventListener('click', (e) => {
      if (this.mainDetailsToggle.open) e.preventDefault();
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
